module.exports = __webpack_public_path__ + "../resources/img/guideStep4.22c7b550.png";